import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Spinner from '../layout/Spinner';

import {Card, ListGroup, CardSubtitle, CardTitle, CardText, ListGroupItem, CardBody, Table, Row} from 'reactstrap';

import { clearApplicationB } from '../../actions/master2';
import { clearApplication2, getProfileCor, clearApplication} from '../../actions/master';
import {listAll, openCert, gettfc} from '../../actions/dload';
import {S3_UPLOAD_CERTIFICATES_LIST, YES_NO_ARRAY, NATIVITY, ELIGIBILITY_TYPE, DIFF_ABLED_TYPES, NATIONALITY, QUALIFYING_DEGREE, PATTERN_OF_STUDY, APPEARANCE_FINAL_YEAR_EXAM} from '../../Constant';

import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import {saveAs} from 'save-as';

//const {GENDER, RELIGION, NATIONALITY, NATIVITY, YES_NO_ARRAY} = require("../../Constant");

const Dload = ({ 
  listAll, gettfc,
  auth: { user }, getProfileCor,
  profile: { profile, allapplns, logprofile, loading, getdb },
  history, 
  clearApplication2  
}) => {

  useEffect(() => {
    window.scrollTo(0,0);
  }, []); 

  useEffect(() => {
    clearApplication2(history);
  }, [clearApplication2, history]); 

  var zip = new JSZip();

    const [sloading, setsLoading] = useState(false);

    async function downzip() {

      setsLoading(true);
      try {

      const remoteZips = allapplns.map(async function(cert) {
        console.log(cert.durl);
        var filename = "filename";
        // loading a file and add it in a zip file
        const response = await fetch(cert.durl);
        const data = await response.blob();
        zip.file(`${cert.id}.${cert.PROPS.ext}`, data);
        return data;
      });
      Promise.all(remoteZips).then(() => {
        zip.generateAsync({ type: "blob" }).then((content) => {
          saveAs(content, `${profile._aid}.zip`);
        });
        setsLoading(false);
      })
      .catch(() => {
        setsLoading(false);
      })

      setsLoading(false);
    } catch(error)
    {
      setsLoading(false);
    }
    };


  var certnames = [];
  certnames.push({key: 1, value: "x"});
  certnames.push({key: 2, value: "xi"});
  certnames.push({key: 2, value: "xii"});
  certnames.push({key: 3, value: "tc"});
  certnames.push({key: 4, value: "passport_photo"});
  certnames.push({key: 5, value: "sign"});

  const [formData, setFormData] = useState({
    gappid: '',
    _aid: '', _n: '',
    vflag : "notyet",
    cremarks: '',
    status: '',
    tfcname: '',
    username: '',
    ltype: ''
  });

  function loadcerts() {
    //console.log("invoking init " + logloading);
    if(loading === true)
    {      
      if(logprofile && logprofile._p && logprofile._p.co !== "OC")
        certnames.push({key: 6, value: "community"});
      
      if(logprofile && logprofile._sr && logprofile._sr.dap === "Y" && logprofile._sr.adt  === "1")
        certnames.push({key: 7, value: "diff_abled_blind"});

      if(logprofile && logprofile._sr && logprofile._sr.dap === "Y" && logprofile._sr.adt === "2")
        certnames.push({key: 7, value: "diff_abled_deaf"});
      
      if(logprofile && logprofile._sr && logprofile._sr.dap === "Y" && logprofile._sr.adt === "3")
        certnames.push({key: 7, value: "diff_abled_loco"});
      
      if(logprofile && logprofile._sr && logprofile._sr.dap === "Y" && logprofile._sr.adt === "4")
        certnames.push({key: 7, value: "diff_abled_autism"});
      
      if(logprofile && logprofile._sr && logprofile._sr.dap === "Y" && logprofile._sr.adt === "5")
        certnames.push({key: 7, value: "diff_abled_multiple"});
      
      if(logprofile && logprofile._sr && logprofile._sr.ex === "Y")
          certnames.push({key: 8, value: "exservice"});

      if(logprofile && logprofile._p && logprofile._p.nt === "TN" && logprofile._sc.sit === "N")
          {
            certnames.push({key: 9, value: "nativity"});
          }
      if(logprofile && logprofile._p && logprofile._sc.sit === "Y" && logprofile._p.nt === "OTH")
          {
            certnames.push({key: 9, value: "eligibility"});
          }

      if(logprofile && logprofile._p && logprofile._p.ny === "SLR")
          certnames.push({key: 10, value: "srilankanRefuge"});


    }
  }

  const { gappid } = formData;

  const onChange = e => {
    setFormData({ ...formData, [e.target.name] : e.target.value });  
    //name: e.target.value to change name alone
    //console.log(e.target.value);
  }

 /* const onDownload = e => {
    e.preventDefault();
    clearProf(e);
    history.push('/download');
  }*/

  const onSubmit = async e => {
    e.preventDefault();     
    
    await clearApplication2(history);
    
    //await gettfc(formData.gappid);       
    //console.log(logprofile);
    
    //await listAll(formData.gappid);
    //console.log("completed retrieving the list");

    await getProfileCor(formData.gappid);
   
  };


  const clearProf = async e => {    
    await clearApplication2(history);
    history.push('/');
    history.push('/dload');
    //await clearApplicationB(history);
    //formData.gappid = '';
  };


  return (    

    <Fragment>
       {user === null ? (
      <Spinner /> ) : ( 
      <>
      <h5 style={{textAlign: 'center', color: "blue", fontSize: "11pt", fontWeight: "bolder"}}>  {user && user.tfcname} </h5>
      <div className="container badge form" style={{textAlign: 'center', fontWeight: 'bolder', 
            color: 'crimson'}}>        
       <h5 style={{fontWeight: "bold"}}> Download Certificates </h5>        
      </div>
      <div className="row">      
        <h2 className="badge">                 
        <form className="form profile" style={{paddingLeft: "200px", alignItems: "center",}} onSubmit = {e => onSubmit(e)}>
            <h3 style={{fontWeight: "bold", fontSize: "12pt"}}>Enter application number </h3> 
                <input type="text" name="gappid" value={gappid} onChange = {e => onChange(e)}/>   
                <div className="container2">
                <input type="submit" className="btn btn-success" value="View List" />       
                <input type="submit"  value="Clear" className="btn btn-primary" onClick= {e => clearProf(e)} />                                        
                </div>             
        </form>
        </h2>
      </div>    
      </> ) }

      {loading === true && getdb === true ? (
        <Spinner /> ) : (
<>  
      {loading ? loadcerts() : null }
      
        {

      allapplns && allapplns.length > 0 && user && user.ltype === 'C'  &&

      
      <div className="m-2">     

        <div className="container badge" style={{fontWeight: 'bold', background: 'lightgrey'}}>
        <h5 style={{fontWeight: "bold", color: "red"}}>                  
              Candidate Details
        </h5>
        </div>         
        
        <Row className="grid-3 badge" style={{fontWeight: "bold", color: "black", textAlign: "center", fontSize: "13pt", border: "1px solid grey", lineHeight: "50px", fontFamily: "verdana"}}>  
            <div>Application Number: {profile._aid} </div>
            <div>Name: {profile._n}</div>
            <div>Course: <span> B.Ed </span></div>
        </Row>
         
             
              <div className="grid-4" style={{textAlign: "center" ,color: "darkred", fontSize: "11pt", fontWeight: "bolder", backgroundColor: "white", border: "1px solid grey"}}>
              <div > Community: <span style={{fontWeight: 'bold', color: "black"}}> {profile && profile._p && profile._p.co} </span> </div>
                
                


                <div > Mobile: <span style={{fontWeight: 'bold', color: "black"}}> 
                {profile.m} </span> </div>

                <div > Email: <span style={{fontWeight: 'bold', color: "black"}}> 
                {profile.e} </span> </div>


              </div>
            
            <div>
            
          </div>


<>
<div className="p-2" />
        <div className="container badge" style={{fontWeight: 'bold', background: 'lightgrey'}}>
        <h5 style={{fontWeight: "bold", color: "navy"}}>                  
            Uploaded Certificates
        </h5>        
        </div>         
        <div className='text-danger'> Number of Certificates Uploaded: {allapplns ? allapplns.length : "0"} </div>


            <div className="table-responsive" style={{paddingTop: "20px", fontWeight: "bold"}}>        
            
            <table className="table" style={{ color: "black", fontSize: "9pt"}} >
            <thead>
              
              <tr style={{color: "black", fontWeight: "bolder"}}>   
                <th style={{backgroundColor: "#E8F8F5"}} scope="col"> Sl.No </th>             
                
                <th style={{backgroundColor: "#E8F8F5"}} scope="col"> Certificate Name </th>                
                                             

                <th style={{backgroundColor: "#E8F8F5"}} scope = "col" > Download File </th> 

                <th style={{backgroundColor: "#E8F8F5"}} scope = "col" > Saved File </th> 
            
              </tr>
            </thead>
            <tbody>
          
          
          {allapplns && allapplns.map((cert, i) => (
            <tr key={i} >            
            <td style={{textAlign: "left", fontSize: "10pt"}}> {i+1} </td>    
            
            <td style={{color: "red", fontWeight: "bold", textAlign: "left", fontSize: "10pt"}}>             
            {cert.id.toString()}
            </td>

            <td style={{color: "red", fontSize: "11pt"}}> 
            
                <a  target="_blank" rel="noopener noreferrer"  style={{textDecoration: "underline", color: "crimson"}} href={cert.durl}> Download </a> 
            </td>

            <td style={{color: "navy", fontSize: "10pt"}}> 
              {cert.fileName} <br /> 
              <span style={{color: "green"}}>
              Size: {cert.PROPS && Math.round(cert.PROPS.size/1024)} KB  
              </span>
            </td>

          </tr>   ) ) }

          </tbody>
          </table>
            
          </div> 
          </>  

          <Row className="my-3 but-center">
          <input type='submit' className='row btn btn-white' style={{color: "navy", fontWeight: "bolder"}} onClick={downzip} value="Download all Certficates as Zip file"/>
          </Row> 

          </div> 
        }
    
    </> ) }

    </Fragment>
    
  );
}

Dload.propTypes = {
  clearApplication2: PropTypes.func.isRequired,
  openCert: PropTypes.func.isRequired,
  gettfc: PropTypes.func.isRequired,
  listAll: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  getProfileCor: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth,
  profile: state.profile
});

export default connect(
  mapStateToProps,
  { clearApplication2, listAll, openCert, gettfc, getProfileCor}
)(Dload);
